import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();

history.listen((location, action) => {
  if (action === 'POP') {
    history.replace({...location, state: { from: null }});
  }
});
